/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Decklists_Help_WinnerInputs */



/**
* | output |
* | --- |
* | "Once the event finishes, only the winner's decklist becomes public." |
*
* @param {Tfield_Decklists_Help_WinnerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_decklists_help_winner = /** @type {((inputs?: Tfield_Decklists_Help_WinnerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Decklists_Help_WinnerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Une fois l'événement terminé, seule la decklist du vainqueur devient publique.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Una vez finalizado el evento, solo la decklist del ganador se hace pública.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Assim que o evento terminar, apenas a decklist do vencedor se torna pública.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Al termine dell'evento, solo la decklist del vincitore diventa pubblica.")
	return /** @type {LocalizedString} */ ("Once the event finishes, only the winner's decklist becomes public.")
});